import { Spinner } from 'react-bootstrap'
import { EventGroup } from './types'
import { EventDateGroup } from './EventDateGroup'
import { ActivityV2 } from 'models/activityV2'
import { TableLinkStyleProvider } from 'components/Tables/CommonTableCells/TableLinkStyleContext'
interface EventHistoryListProps {
  isLoading: boolean
  error: unknown
  groupedEvents: EventGroup[]
  hasNextPage?: boolean
  isFetchingNextPage: boolean
  fetchNextPage: () => void
  onPreviewRequest: (sampleId: number) => void
  onEmailClick?: (event: ActivityV2) => void
}

export function EventHistoryList({
  isLoading,
  error,
  groupedEvents,
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
  onPreviewRequest,
  onEmailClick,
}: EventHistoryListProps) {
  return (
    <TableLinkStyleProvider variant="plain">
      <div className="relative min-h-[100px] pb-6 [&_a]:!font-medium [&_a]:!text-[14px] [&_a]:!leading-5 [&_b]:!font-medium [&_[data-pill]]:!text-[12px] [&_[data-pill]]:!leading-[15px] [&_[data-pill]]:!py-[2px] [&_[data-pill]]:!px-2 [&_[data-pill]]:!rounded-full [&_[data-pill]]:!font-medium">
        {/* Error state */}
        {!!error && (
          <div className="py-8 text-center text-base text-red-500">
            Failed to load event history
          </div>
        )}

        {/* Empty state */}
        {!error && groupedEvents.length === 0 && !isLoading && (
          <div className="py-8 text-center text-base text-gray-500">
            No recent events found
          </div>
        )}

        {/* Content */}
        {!error && groupedEvents.length > 0 && (
          <div className="mt-4 space-y-6 relative">
            {/* Event groups */}
            {groupedEvents.map((group) => (
              <EventDateGroup
                key={group.date}
                group={group}
                onPreviewRequest={onPreviewRequest}
                onEmailClick={onEmailClick}
              />
            ))}

            {/* Load More Button */}
            {hasNextPage && (
              <div className="flex justify-center pt-4 pb-8">
                <button
                  type="button"
                  onClick={() => fetchNextPage()}
                  disabled={isFetchingNextPage}
                  className="inline-flex items-center justify-center gap-2 h-9 px-4 rounded-lg bg-brand-bright text-white text-base font-medium hover:bg-brand-active transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isFetchingNextPage ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span>Loading...</span>
                    </>
                  ) : (
                    <span>Load More Events</span>
                  )}
                </button>
              </div>
            )}
          </div>
        )}

        {/* Loading overlay for tab/search switching (when we have previous data) */}
        {isLoading && (
          <div className="absolute inset-0 bg-white/70 backdrop-blur-sm flex items-center justify-center z-50 rounded">
            <Spinner animation="border" size="sm" />
          </div>
        )}
      </div>
    </TableLinkStyleProvider>
  )
}
